import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
import { workOrderChargeCostSchema } from './work-order-charge-cost-schema.js';
export const updateWorkOrderChargeInputSchema = z.object({
    workOrderItemId: requiredUuidString('Charge is required.', 'Invalid charge selection.'),
    cost: workOrderChargeCostSchema,
});
//# sourceMappingURL=update-charge-input.js.map